export const splitDescription = (description: string) => {
  const regex = /(.*?\()(.*?)(\).*)/;

  return description.match(regex);
};
